// extracted by mini-css-extract-plugin
export default {"card":"QuestCardFeature_card__EmLnL","cardDescription":"QuestCardFeature_cardDescription__l2hUw"};